import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { UploadFilesDialogComponent } from 'src/app/core/dialogs/upload-files-dialog/upload-files-dialog.component';
import { BtnCellRendererDelete } from 'src/app/core/grid/btn-cell-render-delete.component';
import { GridDataService } from 'src/app/service/grid-data.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { ContingencyMasterTableService } from 'src/app/service/pcs/contingency-master-table.service';


@Component({
  selector: 'app-contingency-master-tables',
  templateUrl: './contingency-master-tables.component.html',
  styleUrls: ['./contingency-master-tables.component.scss'],
  standalone: false
})
export class ContingencyMasterTablesComponent implements OnInit {
  @ViewChild('ContPCSGrid') ContPCSGrid;
  @ViewChild('ContLLTGrid') ContLLTGrid;

  PCS_gridApi: any;
  LLT_gridApi: any;
  LLT_columnDefs = [];
  LLT_displayRowData = [];
  PCS_columnDefs = [];
  PCS_displayRowData = [];
  LLT_context: any;
  PCS_context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  PCS_rowCount;
  LLT_rowCount;

  selected_period_id;
  selected_period_value
  selectDoubleShipDate: any
  modifiedDoubleShipDate: any
  selectContingencyDate: any
  modifiedContingencyDate: any
  defaultColDef;
  successMessage
  errorMessage
  isAccessible = true;
  gridOptions
  icons;

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly ngxUiLoaderService : NgxUiLoaderService,
    private readonly contingencyMasterTableService: ContingencyMasterTableService, private readonly constants: Constants, private readonly gridDataService: GridDataService, private readonly groupIStateService : GroupIStateService) {
    this.LLT_context = {
      componentParent: this
    };

    this.PCS_context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, suppressHeaderFilterButton: true, suppressCellSelection: true
    }
  }


  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.gridOptions = this.gridDataService.getGridOptions();
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };

    this.PCS_columnDefs = [
      {
        headerName: "Contingency Production Date", field: "contprodDate",
      },
      {
        headerName: "Doubleship Date", field: "doubleshipDate",
      },
      {
        headerName: "Delete", field: "pcs_master_mini_left",
        cellRenderer: BtnCellRendererDelete, width: 50, maxWidth: 50
      }];
    this.LLT_columnDefs = [
      {
        headerName: "Domicile", field: "domicile", width: 160, maxWidth: 160,
      },
      {
        headerName: "Route", field: "route", width: 160, maxWidth: 160,
      }, {
        headerName: "Contingency", field: "contingency", width: 120, maxWidth: 190,
      }, {
        headerName: "LLT", field: "llt", width: 120, maxWidth: 187,
      }];
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);


  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) ||
    //     userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || 
    //     userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))
    // {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }
  componentEventHandler(event) {

    if (event.eventType == "NOTIFICATION_ERROR") {  // NOSONAR
      this.errorMessage = event.eventMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    } else if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selected_period_id = event.periodId
      this.selected_period_value = event.periodValue
      this.refreshDataPCS();
    }
  }

  refreshDataPCS() {
    if (this.selected_period_id) {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.contingencyMasterTableService.loadDataContingencyMasterPCS(this.selected_period_id).subscribe(
        response => {
          this.PCS_displayRowData = response
          this.PCS_gridApi?.setGridOption('rowData', this.PCS_displayRowData);
          this.PCS_rowCount = this.PCS_displayRowData.length;
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.refreshDataLLT();
        }, _error => {

          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );
    }

  }
  refreshDataLLT() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.contingencyMasterTableService.loadDataContingencyLLT(this.selected_period_id).subscribe(
      response => {
        this.LLT_displayRowData = response
        this.LLT_displayRowData.forEach(element => {
          if (element.contingency == 1) { element.contingency = 'X' }  // NOSONAR
          else { element.contingency = null }
          if (element.llt == 1) { element.llt = 'X' }  // NOSONAR
          else { element.llt = null }
        });
        this.LLT_gridApi?.setGridOption('rowData', this.LLT_displayRowData);
        this.LLT_rowCount = this.LLT_displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }, _error => {

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }
    );

  }


  PCS_sizeToFit() {
    this.PCS_gridApi?.sizeColumnsToFit();
  }
  LLT_sizeToFit() {
    this.LLT_gridApi?.sizeColumnsToFit();
  }
  PCS_onGridReady(params) {
    this.PCS_gridApi = params.api
    this.PCS_gridApi.sizeColumnsToFit();
  }
  LLT_onGridReady(params) {
    this.LLT_gridApi = params.api
    this.LLT_gridApi.sizeColumnsToFit();
  }

  onPCSPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
      {this.PCS_gridApi?.setGridOption('paginationPageSize', Number(this.PCS_displayRowData.length));}
    else
      {this.PCS_gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}
  }

  onLLTPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
      {this.LLT_gridApi?.setGridOption('paginationPageSize', Number(this.LLT_displayRowData.length));}
    else
      {this.LLT_gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}

  }

  goToNexpagePCS() { this.PCS_gridApi.paginationGoToNextPage(); }

  goToPreviousPagePCS() { this.PCS_gridApi.paginationGoToPreviousPage()}

  goToFirstPagePCS() { this.PCS_gridApi.paginationGoToFirstPage(); }

  goToLastPagePCS() { this.PCS_gridApi.paginationGoToLastPage() }

  getCurrentPagePCS(): boolean {
    this.currentPageNo = this.PCS_gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPagePCS(): boolean {
    this.totalPage = Number(this.PCS_gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.PCS_gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }


  goToNexpage() { this.LLT_gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.LLT_gridApi.paginationGoToPreviousPage()}

  goToFirstPage() { this.LLT_gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.LLT_gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.LLT_gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.LLT_gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.LLT_gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
  uploadData() {
    if (this.PCS_rowCount > 0) {
      const dialogRef = this.dialog.open(
        UploadFilesDialogComponent, {
        disableClose: true,
        width: '800px',
        height: '520px',
        data: {
          selected_period: this.selected_period_id
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result.status) {
          this.refreshDataLLT();
          this.refreshDataPCS();
        }
      });

    } else {
      this.errorMessage = this.constants.PCSerrorMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }
  dateChange() {
    if (this.selectDoubleShipDate != undefined) { // NOSONAR
      this.modifiedDoubleShipDate = this.selectDoubleShipDate.split('-');
      this.modifiedDoubleShipDate = this.modifiedDoubleShipDate[1] + '-' + this.modifiedDoubleShipDate[2] + '-' + this.modifiedDoubleShipDate[0]
    }
    if (this.selectContingencyDate != undefined) { // NOSONAR
      this.modifiedContingencyDate = this.selectContingencyDate.split('-');
      this.modifiedContingencyDate = this.modifiedContingencyDate[1] + '-' + this.modifiedContingencyDate[2] + '-' + this.modifiedContingencyDate[0]
    }

  }
  addDatesToPCS() {
    if (!this.selected_period_id) {
      this.errorMessage = "Select Period";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    } else if (!this.modifiedDoubleShipDate) {
      this.errorMessage = "Please select Doubleship Date.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    } else if (!this.modifiedContingencyDate) {
      this.errorMessage = "Please select Contingency Date.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    }
    const dateAlreadyPresent = this.PCS_displayRowData.find(x => x.contprodDate == this.modifiedContingencyDate && x.doubleshipDate == this.modifiedDoubleShipDate)  // NOSONAR
    if (dateAlreadyPresent) {
      this.errorMessage = "Same dates are already present for the selected period.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    }
    if (this.modifiedDoubleShipDate && this.modifiedContingencyDate) {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.contingencyMasterTableService.addPCSDate(this.selected_period_id, this.modifiedContingencyDate, this.modifiedDoubleShipDate).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response != undefined && response != null) { // NOSONAR
            let tempResponse: any = response
            this.successMessage = this.constants.APIDataSaved;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            if (typeof tempResponse == "string")  // NOSONAR
             { tempResponse = JSON.parse(response) }

            this.PCS_displayRowData.push(tempResponse)
            this.PCS_gridApi?.setGridOption('rowData', this.PCS_displayRowData);
            this.PCS_rowCount = this.PCS_displayRowData.length;
            this.selectContingencyDate = this.selectDoubleShipDate = null;

          }


        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        });
    }

  }
  pcsMasterLeftDelete(data, pagename) {
    if (pagename == 'pcs_master_mini_left') {  // NOSONAR
      const dialogRef = this.dialog.open(
        DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '170px',
        data: {
          header: 'Are you sure you want to delete this PCS Record?',
          description: data.contprodDate + ' and ' + data.doubleshipDate + ' with Period ' + this.selected_period_value,
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'ConfirmEvent') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)

          this.contingencyMasterTableService.deleteMasterPCSRecord(data.pcsdateID).subscribe(
            response => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              if (response == "Success") {  // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTime);
                const displayRowIndex = this.PCS_displayRowData.findIndex(x => x.pcsdateID == data.pcsdateID)  // NOSONAR
                this.PCS_displayRowData.splice(displayRowIndex, 1);
                this.PCS_gridApi?.setGridOption('rowData', this.PCS_displayRowData);
                this.PCS_rowCount = this.PCS_displayRowData.length;
              }


            }, _error => {

              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
          );
        }
      });

    }
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
  pad(value: any): string {
    return value.toString().length == 1 ? "0" + value : value;  // NOSONAR
  }
}
